/* eslint-disable */
import { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { Button, Divider, Modal, CardContent, Stack, Table, TableBody, TableCell, TableContainer, TableRow, TextField } from '@mui/material';
import MainCard from 'components/MainCard';
import { Controller, useForm } from 'react-hook-form';
import { getEquipmentCategoriesByQuery } from 'components/axios/equipmentCategoryAxios';
// import { getWorkingPartsByQuery } from 'components/axios/workingPartAxios';
// import { getStationsByQuery } from 'components/axios/stationAxios';
import CustomFormEnumSelect from 'components/select/CustomFormEnumSelect';
import CustomFormSelect from 'components/select/CustomFormSelect';
import useModals from 'components/modals/useModal';
import { modals } from 'components/modals/Modals'; 
import { getEquipmentsById, getEquipmentsByQuery } from 'components/axios/equipmentAxios';
import CustomDateTimePicker from 'components/date_picker/CustomDateTimePicker';
import axios from 'axios';
import moment from 'moment';
import { useEnumApi } from 'contexts/EnumApiContext';
import CustomFormAutocompleteSelect from 'components/select/CustomFormAutocompleteSelect';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';
import Chip from '@mui/material/Chip';
import { customFileAxios } from 'components/axios/customAxios';

const AlertRequestLayer = ({id, 
  // subwayCode : parentSubwayCode, workingPartId : parentWorkingPartId, stationId : parentStationId,
  equipmentCategoryLevel1Id : parentEquipmentCategoryLevel1Id ,equipmentCategoryLevel2Id : parentEquipmentCategoryLevel2Id ,equipmentCategoryLevel3Id : parentEquipmentCategoryLevel3Id
  , setIsLoading : setParentIsLoading, type}) => {
    const { getEnumValueByEnumName } = useEnumApi();
    const { t } = useTranslation();
    // const { name, subway, workingPart } = useSelector(state => state.user);
    const { name } = useSelector(state => state.user);

    // modal 관련
    const { openModal } = useModals();
    let [alertMessage, setAlertMessage] = useState('');
    
    const handleAlertClick = () => {
        openModal(modals.alertModal, {
            onClose : () => {
            },
            message: alertMessage,
        });
    };
 
    const regexDateTime = RegExp(/^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01]) (0[0-9]|1[0-9]|2[0-3]):(0[1-9]|[0-5][0-9])$/);

    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true); setIsLoading(false)};
    const handleClose = () => setOpen(false);

    // const [workingParts, setWorkingParts] = useState([]);
    // const [stations, setStations] = useState([]);
    const [equipmentCategoryLevel1s, setEquipmentCategoryLevel1s] = useState([]);
    const [equipmentCategoryLevel2s, setEquipmentCategoryLevel2s] = useState([]);
    const [equipmentCategoryLevel3s, setEquipmentCategoryLevel3s] = useState([]);
    const [equipments, setEquipments] = useState([]);
  
    const [equipment, setEquipment] = useState(null);

    // const [subwayCode, setSubwayCode] = useState('');
    // const [workingPartId, setWorkingPartId] = useState('');
    // const [stationId, setStationId] = useState('');
    const [equipmentCategoryLevel1Id, setEquipmentCategoryLevel1Id] = useState('');
    const [equipmentCategoryLevel2Id, setEquipmentCategoryLevel2Id] = useState('');
    const [equipmentCategoryLevel3Id, setEquipmentCategoryLevel3Id] = useState('');
    const [equipmentId, setEquipmentId] = useState('');
    const [equipmentNo, setEquipmentNo] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const { control, register, handleSubmit, reset, setValue, formState : {isDirty, errors } } = useForm({});

    useEffect(() => {
      // if (parentSubwayCode || subway) {
      //   setSubwayCode(parentSubwayCode || subway);
      // }
      if (parentEquipmentCategoryLevel1Id) {
        setEquipmentCategoryLevel1Id(parentEquipmentCategoryLevel1Id);
      }
    // },[parentSubwayCode, subway, parentEquipmentCategoryLevel1Id]);
    },[parentEquipmentCategoryLevel1Id]);
    
    useEffect(()=>{
      if (id && open) {
        getEquipmentsByQuery({id}).then((data) => {
          if (data && data._embedded) {
            const list = data._embedded.equipments;
            if (list && list.length > 0) {
              setEquipment({label:list[0].name , id:list[0].id});
              // setSubwayCode(list[0].station && list[0].station.workingPart && list[0].station.workingPart.subwayLine);
              // setValue('subwayCode', ((list[0].station && list[0].station.workingPart && list[0].station.workingPart.subwayLine) || null));
              // setWorkingPartId(list[0].station && list[0].station.workingPart && list[0].station.workingPart.id);
              // setValue('workingPartId', ((list[0].station && list[0].station.workingPart && list[0].station.workingPart.id) || null));
              // setStationId(list[0].station && list[0].station.id);
              // setValue('stationId', ((list[0].station && list[0].station.id) || null));
              setEquipmentCategoryLevel1Id(list[0].equipmentCtgr && list[0].equipmentCtgr.parent && list[0].equipmentCtgr.parent.parent && list[0].equipmentCtgr.parent.parent.id);
              setValue('equipmentCategoryLevel1Id', ((list[0].equipmentCtgr && list[0].equipmentCtgr.parent && list[0].equipmentCtgr.parent.parent && list[0].equipmentCtgr.parent.parent.id) || null));
              setEquipmentCategoryLevel2Id(list[0].equipmentCtgr && list[0].equipmentCtgr.parent && list[0].equipmentCtgr.parent.id);
              setValue('equipmentCategoryLevel2Id', ((list[0].equipmentCtgr && list[0].equipmentCtgr.parent && list[0].equipmentCtgr.parent.id) || null));
              setEquipmentCategoryLevel3Id(list[0].equipmentCtgr && list[0].equipmentCtgr.id);
              setValue('equipmentCategoryLevel3Id', ((list[0].equipmentCtgr && list[0].equipmentCtgr.id) || null));
              setEquipmentId((list[0].id || null));
              setValue('equipmentId', (list[0].id || null));
              setEquipmentNo((list[0].equipmentNo || null));
              setValue('equipmentNo', (list[0].equipmentNo || null));
              return list[0];
            } else {
              setEquipment(null);
              return {};
            }
          }
        }).then((res)=>{
        })
      }
    },[id, open]);

    useEffect(() => {
      if (open) {
        Promise.all([
            getEquipmentCategoriesByQuery({ depth: 1, size : 100, sort : "name,asc" }).then((data) => {
                if (data && data._embedded) {
                    const list = data._embedded.equipmentCategories;
                    if (list) {
                        setEquipmentCategoryLevel1s(list);
                    } else {
                        setEquipmentCategoryLevel1s([]);
                    }
                } else {
                    setEquipmentCategoryLevel1s([]);
                }
            })
        ]).then((res) => {
            setIsLoading(true);
        });
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    // },[open, parentSubwayCode, subway]);
    },[open]);

    // 호선 선택시 해당 파트 목록 가져오기
    // useEffect(()=>{
    //   if ((subwayCode || parentSubwayCode || subway) && open) {
    //       const param = {"subwayLine" : (subwayCode || parentSubwayCode || subway), size:50}
    //       getWorkingPartsByQuery(param).then((data)=>{
    //           if (data && data._embedded) {
    //               let workingParts = data._embedded.workingParts;
    //               setWorkingParts(workingParts);
    //               const wId = (workingPartId || parentWorkingPartId || workingPart) || (equipment && equipment.station && equipment.station.workingPart && equipment.station.workingPart.id) || '';
    //               let belongDatas = null;
    //               if (wId) {
    //                 setWorkingPartId(wId);
    //                 belongDatas = data._embedded.workingParts.filter(item=> item.id == wId);
    //               }                 
    //               if (wId && belongDatas && belongDatas.length > 0) {
    //                 setValue("workingPartId", wId);
    //               } else if (equipment && equipment.station && equipment.station.workingPart) {
    //                 setValue("workingPartId", (equipment.station.workingPart.id || ''));
    //               } else {
    //                 setWorkingPartId('');
    //                 setValue("workingPartId", '');
    //               }
    //           } else {
    //               setWorkingPartId('');
    //               setValue("workingPartId", '');
    //               setWorkingParts([]);
    //           }
    //           setStations([]);
    //           setEquipments([]);
    //       });
    //   }
    // },[subwayCode, parentSubwayCode, subway, open]);

    // // 파트 선택시 해당 역사 목록 가져오기
    // useEffect(()=>{
    //   if ((workingPartId || parentWorkingPartId || workingPart) && open) {
    //       const param = {"workingPart.id" : (workingPartId || parentWorkingPartId || workingPart), sort:"code,asc", size:50};
    //       getStationsByQuery(param).then((data)=>{
    //           if (data && data._embedded) {
    //               setStations(data._embedded.stations);
    //               const sId = (stationId || parentStationId) || (equipment && equipment.station && equipment.station.id) || '';
    //               let belongDatas = null;
    //               if (sId) {
    //                 setStationId(sId);
    //                 belongDatas = data._embedded.stations.filter(item=> item.id == sId);
    //               }                 
    //               if (sId && belongDatas && belongDatas.length > 0) {
    //                 setValue("stationId", sId);
    //               } else if (equipment && equipment.station) {
    //                 setValue("stationId", (equipment.station.id || ''));
    //               } else {
    //                 setStationId('');
    //                 setValue("stationId", '');
    //               }
    //           } else {
    //               setStationId('');
    //               setValue("stationId", '');
    //               setStations([]);
    //           }
    //           setEquipments([]);
    //       });
    //   }
    // },[workingPartId, parentWorkingPartId, workingPart, open]);

    // 설비중분류 목록
    useEffect(()=>{
        if ((equipmentCategoryLevel1Id || parentEquipmentCategoryLevel1Id) && open) {
            const param = { "parent.id": (equipmentCategoryLevel1Id || parentEquipmentCategoryLevel1Id), depth: 2, size : 100, sort : "name,asc" };
            getEquipmentCategoriesByQuery(param).then((data) => {
                if (data && data._embedded) {
                    setEquipmentCategoryLevel2s(data._embedded.equipmentCategories);
                    const sId = ((equipmentCategoryLevel2Id || parentEquipmentCategoryLevel2Id) || (equipment && equipment.equipmentCtgr && equipment.equipmentCtgr.parent && equipment.equipmentCtgr.parent.id) || '');
                    let belongDatas = null;
                    if (sId) {
                      setEquipmentCategoryLevel2Id(sId);
                      belongDatas = data._embedded.equipmentCategories.filter(item=> item.id == sId);
                    }                 
                    if (sId && belongDatas && belongDatas.length > 0) {
                      setValue("equipmentCategoryLevel2Id", sId);
                    } else if (equipment && equipment.equipmentCtgr && equipment.equipmentCtgr.parent) {
                      setValue("equipmentCategoryLevel2Id", (equipment && equipment.equipmentCtgr && equipment.equipmentCtgr.parent && equipment.equipmentCtgr.parent.id) || '');
                    } else {
                      setEquipmentCategoryLevel2Id('');
                      setValue("equipmentCategoryLevel2Id", '');
                    }
                } else {
                    setEquipmentCategoryLevel2Id('');
                    setValue("equipmentCategoryLevel2Id",'');
                    setEquipmentCategoryLevel2s([]);
                }
                setEquipmentCategoryLevel3s([]);
                setEquipments([]);
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[equipmentCategoryLevel1Id, parentEquipmentCategoryLevel1Id, open]);

    // 설비분류 목록
    useEffect(()=>{
        if ((equipmentCategoryLevel2Id || parentEquipmentCategoryLevel2Id) && open) {
            const param = { "parent.id": (equipmentCategoryLevel2Id || parentEquipmentCategoryLevel2Id), depth: 3, size : 100, sort : "name,asc" };
            getEquipmentCategoriesByQuery(param).then((data) => {
                if (data && data._embedded) {
                    setEquipmentCategoryLevel3s(data._embedded.equipmentCategories);
                    const sId = ((equipmentCategoryLevel3Id || parentEquipmentCategoryLevel3Id) || (equipment && equipment.equipmentCtgr && equipment.equipmentCtgr.id) || '');
                    let belongDatas = null;
                    if (sId) {
                      belongDatas = data._embedded.equipmentCategories.filter(item=> item.id == sId);
                    }                 
                    if (sId && belongDatas && belongDatas.length > 0) {
                      setEquipmentCategoryLevel3Id(sId);
                      setValue("equipmentCategoryLevel3Id", sId);
                    } else if (equipment && equipment.equipmentCtgr && equipment.equipmentCtgr.parent) {
                      setEquipmentCategoryLevel3Id((equipment.equipmentCtgr && equipment.equipmentCtgr.id) || '');
                      setValue("equipmentCategoryLevel3Id", ((equipment.equipmentCtgr && equipment.equipmentCtgr.id) || ''));
                    } else {
                      setEquipmentCategoryLevel3Id('');
                      setValue("equipmentCategoryLevel3Id", '');
                    }
                } else {
                    setEquipmentCategoryLevel3Id('');
                    setValue("equipmentCategoryLevel3Id", '');
                    setEquipmentCategoryLevel3s([]);
                }
                setEquipments([]);
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[equipmentCategoryLevel2Id, parentEquipmentCategoryLevel2Id, open]);

    // 설비목록 
    useEffect(()=>{
      // if ((subwayCode && workingPartId && stationId && equipmentCategoryLevel1Id && equipmentCategoryLevel2Id && equipmentCategoryLevel3Id) && open) {
      if ((equipmentCategoryLevel1Id && equipmentCategoryLevel2Id && equipmentCategoryLevel3Id) && open) {
          const param = { 
            // "station.workingPart.subwayLine" : subwayCode,
            // "station.workingPart.id" : workingPartId,
            // "station.id" : stationId,
            "equipmentCtgr.parent.parent.id" : equipmentCategoryLevel1Id,
            "equipmentCtgr.parent.id" : equipmentCategoryLevel2Id,
            "equipmentCtgr.id" : equipmentCategoryLevel3Id,
            size : 200
          };
          getEquipmentsByQuery(param).then((data) => {
              if (data && data._embedded) {
                  const list = data._embedded.equipments;
                  if (list) {
                    let equipmentSelects = [];
                    list.map(function(equipment, i) {
                        equipmentSelects.push({label:equipment.name , id:equipment.id})
                    })
                    setEquipments(equipmentSelects);
                  } else {
                    setEquipments([]);
                  }
              } else {
                setEquipments([]);
              }
          });
      } else {
      }
    // },[subwayCode, workingPartId, stationId, equipmentCategoryLevel1Id,equipmentCategoryLevel2Id,equipmentCategoryLevel3Id, open]);
    },[equipmentCategoryLevel1Id,equipmentCategoryLevel2Id,equipmentCategoryLevel3Id, open]);

    useEffect(()=>{
      if (equipmentId) {
        getEquipmentsById(equipmentId).then((data)=>{
          if (data) {
            setEquipmentNo(data.equipmentNo);
            setValue('equipmentNo', data.equipmentNo);
          }
        })
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },[equipmentId]);

    const onSubmit = (data, e) => {
      if (data.alertedAt != null && data.alertedAt != '' && !regexDateTime.test(data.alertedAt)) {
        alertMessage = t('message.common.alert.alert.datetime.input');
        setAlertMessage(alertMessage);
        handleAlertClick();
        return;
      }

      let alertedAt = (data.alertedAt?.$d != null ? moment(data.alertedAt.$d).format() : dayjs(data.alertedAt).format());
      let chkedAt = moment().format();

      let dto = {
        equipment : {
          id : data.equipmentId
        },
        alertedAt : alertedAt,
        alertType : data.alertType,
        alertCategory : data.alertCategory,
        alertDtl : data.alertDtl,
        status : "D",  // 경보발생
        chkedAt : chkedAt,
        chkUser : data.chkUser,
        statusReport : {
          reportYmd : null
        },
        fieldStatusReport : {
          reportYmd : null
        }
      }
console.log(dto)
      let formData = new FormData();
      formData.append("dto", new Blob([JSON.stringify(dto)], {type: "application/json"}) );

      openModal(modals.confirmModal, {
        onSubmit : (value) => {
          try {
              const res = customFileAxios.post(`/api/equipmentAlerts`, formData).then((res)=>{
                  //setFileLoading(false);
                  //refreshEquipments();
                  alertMessage = t('message.common.alert.write.done');
                  setAlertMessage(alertMessage);
                  handleAlertClick();
                  setParentIsLoading(false);
                  reset();
                  handleClose();
              }).catch((err)=>{
                  console.log(err);
                  //setFileLoading(false);
                  if (!err.response?.data?.message) {
                      alertMessage = err.message;
                      setAlertMessage(alertMessage);
                      handleAlertClick();
                  } else if (err.response.data.message) {
                      alertMessage = err.response.data.message;
                      setAlertMessage(alertMessage);
                      handleAlertClick();
                  }
              });
              // return res.data;
          } catch (error) {
              console.error("error :", error);
              throw error;
          }
          
          // axios({
          //   method: "post",
          //   url: process.env.REACT_APP_API_URL+"/api/equipmentAlerts",
          //   data: formData,
          //   headers : {
          //       'Content-type' : 'multipart/form-data',
          //       accept : 'application/json,',
          //       'Authorization': `Bearer ${localStorage.getItem("persist:root") && JSON.parse(localStorage.getItem("persist:root")).authToken && JSON.parse(JSON.parse(localStorage.getItem("persist:root")).authToken).accessToken}`,
          //       'Accept-Language' : t('locale')
          //   }
          // }).then((res)=>{
          //     alertMessage = t('message.common.alert.write.done');
          //     setAlertMessage(alertMessage);
          //     handleAlertClick();
          //     setParentIsLoading(false);
          //     reset();
          //     handleClose();
          // }).catch((err)=>{
          //     console.log(err);
          //     if (!err.response?.data?.message) {
          //         alertMessage = err.message;
          //         setAlertMessage(alertMessage);
          //         handleAlertClick();
          //     } else if (err.response.data.message) {
          //         alertMessage = err.response.data.message;
          //         setAlertMessage(alertMessage);
          //         handleAlertClick();
          //     }
          // });
        },
        onClose : () => {
            console.log('close');
        },
        message: t('message.common.alert.write.question'),
      });
    }

    return (
      <>
        {type && type === 'icon' &&
        <Button variant="contained" onClick={handleOpen} style={{padding:"3px", minWidth:"unset", backgroundColor:"unset"}}>
          <span className="icon_png"><img src={`${process.env.PUBLIC_URL}/img/icon/build.png`} alt='' /></span>
        </Button>
        }
        {(type === null || type === undefined || type === 'button') &&
        <Button variant="contained" onClick={handleOpen} style={{minWidth:"unset"}}>
          {t('message.common.btn.inspection.request')}
        </Button>
        }

        <Modal className="pop_box pop_box1" open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
          <MainCard modal darkTitle content={false}>
            <div style={{display:"flex", alignItems: "center", justifyContent: "space-between", margin: "5px 0 10px 0"}}>
              <div>
                <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/popbullet.png`} alt='' /></span>&nbsp;
                <Chip label={t('message.common.chip.alert.failure.inspection.request')} color="success" />
              </div>

              <div>
                <Button variant="contained" color="primary" size="small" onClick={handleClose}>
                  {t('message.common.btn.close')}
                </Button>
              </div>
            </div>

            <CardContent>
              <form onSubmit={handleSubmit(onSubmit)}>
              <TableContainer>
                <Table sx={{ minWidth: 1000 }} aria-label="simple table" className="same_width pop_table">
                  <TableBody>
                    {/* <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.subwayline')}</TableCell>
                      <TableCell>
                        {getEnumValueByEnumName("SubwayLine") && 
                        <Controller
                            sx={{ m: 1, minWidth: "90%" }}
                            control={control}
                            name="subwayCode"
                            render={({ field: {name} }) => (
                            <CustomFormEnumSelect
                                key={subwayCode}
                                style={{ minWidth: '90%' }}
                                label={t('message.common.subtitle.subwayline')}
                                register={register}
                                name={name}
                                defaultValue={subwayCode}
                                onChange={(e)=>{
                                    setSubwayCode(e.target.value);
                                    setWorkingPartId('');
                                    setValue('workingPartId', '');
                                    setStationId('');
                                    setValue('stationId', '');
                                    setEquipmentId('');
                                    setValue('equipmentId', '');
                                    setEquipmentNo('');
                                    setValue('equipmentNo', '');
                                    setEquipments([]);
                                }}
                                list={getEnumValueByEnumName("SubwayLine")}
                            />
                            )}
                        />
                        }
                      </TableCell>
                      <TableCell className="th">{t('message.common.subtitle.workingPart')}</TableCell>
                      <TableCell>
                        {workingParts && 
                        <Controller
                            sx={{ m: 1, minWidth: "90%" }}
                            control={control}
                            name="workingPartId"
                            render={({ field: {name} }) => (
                            <CustomFormSelect
                                key={workingPartId}
                                style={{ minWidth: '90%' }}
                                label={t('message.common.subtitle.workingPart')}
                                register={register}
                                name={name}
                                defaultValue={workingPartId}
                                onChange={(e)=>{
                                    setWorkingPartId(e.target.value);
                                    setStationId('');
                                    setEquipmentId('');
                                    setValue('equipmentId', '');
                                    setEquipmentNo('');
                                    setValue('equipmentNo', '');
                                    setEquipments([]);
                                }}
                                list={workingParts}
                            />
                            )}
                        />
                        }
                      </TableCell>
                      <TableCell className="th">{t('message.common.subtitle.station')}</TableCell>
                      <TableCell>
                        {stations &&
                        <Controller
                            sx={{ m: 1, minWidth: "90%" }}
                            control={control}
                            name="stationId"
                            render={({ field: {name} }) => (
                            <CustomFormSelect
                                key={stationId}
                                style={{ minWidth: '90%' }}
                                label={t('message.common.subtitle.station')}
                                register={register}
                                name={name}
                                defaultValue={stationId}
                                onChange={(e)=>{
                                    setStationId(e.target.value);
                                }}
                                list={stations}
                            />
                            )}
                        />
                        }
                      </TableCell>
                    </TableRow> */}
  
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.equipment.level1')}</TableCell>
                      <TableCell>
                        {equipmentCategoryLevel1s && 
                        <Controller
                            sx={{ m: 1, minWidth: "90%" }}
                            control={control}
                            name="equipmentCategoryLevel1Id"
                            render={({ field: {name} }) => (
                            <CustomFormSelect
                                key={equipmentCategoryLevel1Id}
                                style={{ minWidth: '90%', maxWidth: '110px' }}
                                label={t('message.common.subtitle.equipment.level1')}
                                register={register}
                                name={name}
                                defaultValue={equipmentCategoryLevel1Id}
                                onChange={(e)=>{
                                    setEquipmentCategoryLevel1Id(e.target.value);
                                    setEquipmentCategoryLevel2Id('');
                                    setEquipmentCategoryLevel3Id('');
                                    setEquipmentId('');
                                    setValue('equipmentId', '');
                                    setEquipmentNo('');
                                    setValue('equipmentNo', '');
                                    setEquipments([]);
                                }}
                                list={equipmentCategoryLevel1s}
                            />
                            )}
                        />
                        }
                      </TableCell>
                      <TableCell className="th">{t('message.common.subtitle.equipment.level2')}</TableCell>
                      <TableCell>
                        {equipmentCategoryLevel2s &&
                        <Controller
                            sx={{ m: 1, minWidth: "90%" }}
                            control={control}
                            name="equipmentCategoryLevel2Id"
                            render={({ field: {name} }) => (
                            <CustomFormSelect
                                key={equipmentCategoryLevel2Id}
                                style={{ minWidth: '90%', maxWidth: '110px' }}
                                label={t('message.common.subtitle.equipment.level2')}
                                register={register}
                                name={name}
                                defaultValue={equipmentCategoryLevel2Id}
                                onChange={(e)=>{
                                    setEquipmentCategoryLevel2Id(e.target.value);
                                    setEquipmentCategoryLevel3Id('');
                                    setEquipmentId('');
                                    setValue('equipmentId', '');
                                    setEquipmentNo('');
                                    setValue('equipmentNo', '');
                                    setEquipments([]);
                                }}
                                list={equipmentCategoryLevel2s}
                            />
                            )}
                        />
                        }
                      </TableCell>
                      <TableCell className="th">{t('message.common.subtitle.equipment.level3')}</TableCell>
                      <TableCell>            
                        <Controller
                            sx={{ m: 1, minWidth: "90%" }}
                            control={control}
                            name="equipmentCategoryLevel3Id"
                            render={({ field: {name} }) => (
                            <CustomFormSelect
                                key={equipmentCategoryLevel3Id}
                                style={{ minWidth: '90%', maxWidth: '110px' }}
                                label={t('message.common.subtitle.equipment.level3')}
                                register={register}
                                name={name}
                                defaultValue={equipmentCategoryLevel3Id}
                                onChange={(e)=>{
                                    setEquipmentCategoryLevel3Id(e.target.value);
                                }}
                                list={equipmentCategoryLevel3s}
                            />
                            )}
                        />
                      </TableCell>
                    </TableRow>
  
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.equipment.name')} *</TableCell>
                      <TableCell colSpan="3">
                        <CustomFormAutocompleteSelect
                            freesolo
                            key={equipmentId}
                            style={{width:"96%",marginLeft:"10px"}}
                            labelName={t('message.common.subtitle.equipment.name')}
                            register={register}
                            name="equipmentId"  
                            autoSelect={true}
                            defaultValue={equipment || null}
                            requiredMessage={t('message.common.error.text.equipment.name.select')}
                            list={equipments}
                            onChange={(event, newValue, reason)=>{
                                if(reason !== 'clear'){
                                  setEquipmentId(newValue.id);
                                  setValue('equipmentId', newValue.id);
                                  setEquipment(newValue);
                                }
                            }}
                        />
                        {errors.equipmentId && <small role="alert"><br></br>{errors.equipmentId.message}</small>}
                      </TableCell>
                      <TableCell className="th">{t('message.common.subtitle.equipment.number')} *</TableCell>
                      <TableCell>
                        <TextField style={{width:"90px"}} id="outlined-basic" 
                          aria-invalid={!isDirty ? undefined : errors.equipmentNo ? "true" : "false"}
                          {...register("equipmentNo", {
                              required : t('message.common.error.text.equipment.number.input')
                          })} 
                          disabled
                          key={equipmentNo}
                          defaultValue={equipmentNo}
                          sx={{ minWidth: '90%' }} />
                      </TableCell>
                    </TableRow>
  
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.alertedAt')} *</TableCell>
                      <TableCell colSpan="3">
                        <Controller
                          control={control}
                          name="alertedAt"
                          render={({ field: { name, value, ...field }, ref, fieldState }) => (
                          <CustomDateTimePicker 
                            style={{width:"96%", textAlign:"cneter"}}
                            defaultValue={dayjs(new Date()).format('YYYY-MM-DD HH:mm')}
                            field={field} ref={ref} name={name} value={value} register={register} 
                            setValue={setValue} fieldState={fieldState}
                            requiredMessage={t('message.common.error.text.alert.date.input')}
                       />
                        )}
                        />
                      </TableCell>
                      <TableCell className="th">{t('message.common.subtitle.alertType')} *</TableCell>
                      <TableCell>
                        <Controller
                          sx={{ m: 1, minWidth: "90%" }}
                          aria-invalid={!isDirty ? undefined : errors.alertType ? "true" : "false"}
                          control={control}
                          name="alertType"
                          render={({ field: {name} }) => (
                          <CustomFormEnumSelect
                              style={{ minWidth: '90%' }}
                              label={t('message.common.subtitle.alertType')}
                              register={register}
                              name={name}
                              requiredMessage={t('message.common.error.text.alert.type.select')}
                              // defaultValue={'MON'}
                              list={getEnumValueByEnumName("AlertType").filter(t=>t.code === 'MNT' || t.code === 'MON')}
                          />
                          )}
                        />
                        {errors.alertType && <small role="alert"><br></br>{errors.alertType.message}</small>}
                      </TableCell>
                    </TableRow>
  
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.alertCategory')} *</TableCell>
                      <TableCell>
                        <Controller
                          sx={{ m: 1, minWidth: "90%" }}
                          aria-invalid={!isDirty ? undefined : errors.alertCategory ? "true" : "false"}
                          control={control}
                          name="alertCategory"
                          render={({ field: {name} }) => (
                          <CustomFormEnumSelect
                              style={{ minWidth: '90%' }}
                              label={t('message.common.subtitle.alertCategory')}
                              register={register}
                              name={name}
                              requiredMessage={t('message.common.error.text.alert.category.select')}
                              // defaultValue={'MNT_IR'}
                              list={getEnumValueByEnumName("AlertCategory").filter(c=>c.code === 'MNT_FA' || c.code === 'MNT_IR' || c.code === 'MNT')}
                          />
                          )}
                        />
                        {errors.alertCategory && <small role="alert"><br></br>{errors.alertCategory.message}</small>}
                      </TableCell>
                      <TableCell rowSpan={2} className="th">{t('message.common.subtitle.alertDetail')} *</TableCell>
                      <TableCell rowSpan={2} colSpan="3">
                        <TextField id="outlined-multiline-static" 
                          aria-invalid={!isDirty ? undefined : errors.alertDtl ? "true" : "false"}
                          {...register("alertDtl", {
                              required : t('message.common.error.text.alert.detail.input')
                          })} 
                          multiline
                          sx={{ m: 1, minWidth: '96%' }}
                          rows={4}
                          // defaultValue={t('message.common.select.control.alarm.occurs')}
                          />
                        {errors.alertDtl && <small role="alert"><br></br>{errors.alertDtl.message}</small>}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.alert.check.user')} *</TableCell>
                      <TableCell>
                        <TextField  style={{width:"90px"}} id="outlined-basic" 
                          aria-invalid={!isDirty ? undefined : errors.chkUser ? "true" : "false"}
                          {...register("chkUser", {
                              required : t('message.common.error.text.alert.checker.input')
                          })} 
                          defaultValue={name || ''}
                          sx={{ minWidth: '90%' }} />
                        {errors.chkUser && <small role="alert"><br></br>{errors.chkUser.message}</small>}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
              </form>
            </CardContent>
            <Divider />
            <Stack direction="row" spacing={1} justifyContent="flex-end" sx={{ px: 2.5, py: 2 }}>
              <Button variant="contained" size="small" onClick={handleSubmit(onSubmit)}>{t('message.common.btn.write')}</Button>
              <Button variant="contained" color="error" size="small" onClick={handleClose}>
                {t('message.common.btn.cancel')}
              </Button>
            </Stack>
          </MainCard>
        </Modal>
      </>
    )
}

export default AlertRequestLayer;
